import { Heading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { TilesSelectGroup } from "../generic/TileSelectGroup";
import { getContractType } from "../../data/contractType";
import { BrandType as Brand } from "@bus/models";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const ContractType = () => {
    const { t } = useTranslation(["question4page"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const getTitle = () => {
        switch (brand) {
            case Brand.VWN:
                return t("question4page:finance-type.titleVWN");
            case Brand.VW:
            case Brand.AUDI:
            case Brand.SKODA:
                return t("question4page:finance-type.titleAlternative", {
                    brand: capitalizeBrand(brand as Brand),
                });
            default:
                return t("question4page:finance-type.title", {
                    brand: capitalizeBrand(brand as Brand),
                });
        }
    }
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{`${getTitle()} (Opzionale)`}</Heading>
            <TilesSelectGroup
                fieldName="contractType"
                list={getContractType(t)}
                className="u-1/3 u-1/2@l u-1/1@s ContractType"
            />
        </>
    );
};
